/**
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-19 09:59:56
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2024-12-19 14:41:25
 * @FilePath: src/api/user.js
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */
/**
* @Author 22030124/xieyq
* @Date 2023-11-20 17:11:52
* @Description 请求接口 =》用户相关接口js
*/
import request from '@/utils/request'
import store from '@/store'

// 根据code获取配置
export function getConfigByCode(params) {
  return request({
    url: `/base/sys_conf_item/portal/findByCode`,
    method: 'get',
    params
  })
}

export function getConfigListByCategory(params) {
  // console.log(store.state.user.sysConfig.iamMgtUrl, 'store.state.user.sysConfig.iamMgtUrl')
  return request.get(`/eiam-mgt-api/sys_conf_item/list?category=${params.category}&clientId=${params.clientId}`, { baseURL: store.state.user.sysConfig.iamMgtUrl })
}
// 添加内容
export function setConfig(data) {
  return request({
    baseURL: store.state.user.sysConfig.iamMgtUrl,
    url: `/eiam-mgt-api/sys_conf_item`,
    method: 'post',
    data
  })
}
// 添加内容
export function setClientEndConfig(data) {
  return request({
    url: `/base/sys_conf_item`,
    method: 'post',
    data
  })
}
export function listAllClientByCode(params) {
  return request({
    baseURL: store.state.user.sysConfig.iamMgtUrl,
    url: `/eiam-mgt-api/sys_conf_item/listAllClient`,
    method: 'get',
    params
  })
}
export function deleteClientConfig(params) {
  return request({
    baseURL: store.state.user.sysConfig.iamMgtUrl,
    url: `/eiam-mgt-api/sys_conf_item/deleteClientConfig`,
    method: 'delete',
    params
  })
}
export function listAllApp() {
  return request({
    baseURL: store.state.user.sysConfig.iamMgtUrl,
    url: `/eiam-mgt-api/sys_conf_item/listAllApp`,
    method: 'get'
  })
}

// 更新用户头像
export function updateUserAvatar(base64Image) {
  return request({
    url: '/base/user/changeUserInfo',
    method: 'post',
    data: {
      base64Image
    }
  })
}

// 修改密码
export function changePassword(oldPassword, password, confirmPassword) {
  return request({
    url: '/base/user/changePassword',
    method: 'post',
    data: {
      oldPassword,
      password,
      confirmPassword
    }
  })
}

/**
 * 更新用户个性签名
 * @param {string} signature 个性签名
 * @returns {Promise} 返回API请求结果
 */
export function updateUserSignature(signature) {
  return request({
    url: '/base/user/changeUserInfo',
    method: 'post',
    data: {
      signature
    }
  })
}
